import { render } from "./Header.vue?vue&type=template&id=b7bdcfe8&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=b7bdcfe8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bdcfe8"]])

export default __exports__